import { Form, Input } from "antd";

const layout = {
  size: "large",
};

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};
/* eslint-enable no-template-curly-in-string */

function ContactFormCard({ onPress }) {
  const onFinish = (values) => {
    onPress(values);
  };

  return (
    <div>
      <Form
        name="nest-messages"
        onFinish={onFinish}
        style={{
          width: "100%",
          // display: "flex",
          // flexDirection: "column",
          // justifyContent: "center",
          // alignItems: "center",
        }}
        validateMessages={validateMessages}
      >
        <Form.Item
          name={["Username"]}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input placeholder="Name" {...layout} />
        </Form.Item>
        <Form.Item
          name={["Email"]}
          rules={[
            {
              type: "email",
              required: true,
            },
          ]}
        >
          <Input placeholder="Email" {...layout} />
        </Form.Item>

        <Form.Item
          name={["Subject"]}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input placeholder="Subject" {...layout} />
        </Form.Item>
        <Form.Item
          name={["Message"]}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input.TextArea placeholder="Message" {...layout} />
        </Form.Item>
        <Form.Item
          wrapperCol={{
            ...layout.wrapperCol,

            offset: 9,
          }}
        >
          <button type="primary" htmlType="submit" className="btn btn-primary">
            Send Message
          </button>
        </Form.Item>
      </Form>
    </div>
  );
}

export default ContactFormCard;
